/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import "../../components/RegisterForm/RegisterForm.css";
import "./RegisterPage.css";
import "../login/LoginPage.css";

import {
  onRegisterUser,
  onRegisterUserReset,
} from "../../../Store/Slices/registerSlice";
import {
  useAppDispatch,
  useEnquiryData,
  useRegisterUserData,
} from "../../../Utility";
import { setIsLoggedIn } from "../../../Store/Slices/utilitySlice";
import { setAccessToken } from "../../../utils/auth";
import SuccessModal from "../../components/SuccessModal";
import toast from "react-hot-toast";
import { brand } from "../../../config/appData";
// Components
import UserRegistrationForm from "./components/UserRegistrationForm";
import BusinessSimpleRegistrationForm from "./components/BusinessSimpleRegistrationForm";
import { onEnquiryPost, onEnquiryPostReset } from "../../../Store/Slices/enquirySlice";

function RegisterPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isBusiness = searchParams.get("type") === "business";
  const fromBusiness = searchParams.get("from") === "business";
  const registerUserData = useRegisterUserData();
  const savedEnquiryData = sessionStorage.getItem("enquiryData");
  const enquiryData = useEnquiryData();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const dispatch = useAppDispatch();
  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validatePassword = (password) => {
    if (password.length < 6) {
      return "Password must be at least 6 characters";
    }
    if (!/[A-Z]/.test(password)) {
      return "Password must contain at least 1 capital alphabet";
    }
    if (!/[0-9!@#$%^&*(),.?":{}|<>]/.test(password)) {
      return "Password must contain at least 1 numeric or special character";
    }
    return null;
  };

  const validateForm = () => {
    const newErrors = {};

    if (isBusiness) {
      // Business registration: same 4 fields as user (Name, Email, Phone, Password + Confirm)
      if (!formData.name.trim()) {
        newErrors.name = "Name is required";
      }

      if (!formData.email.trim()) {
        newErrors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Email is invalid";
      }

      const cleanedPhone = formData.phone.replace(/\D/g, "");

      if (!formData.phone.trim()) {
        newErrors.phone = "Phone number is required";
      } else if (!/^(0\d{10}|91\d{10}|\d{10})$/.test(cleanedPhone)) {
        newErrors.phone = "Please enter a valid phone number";
      }

      if (!formData.password) {
        newErrors.password = "Password is required";
      } else if (validatePassword(formData.password)) {
        newErrors.password = validatePassword(formData.password);
      }

      if (!formData.confirmPassword) {
        newErrors.confirmPassword = "Please confirm your password";
      } else if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
      }
    } else {
      // User registration validations
      if (!formData.name.trim()) {
        newErrors.name = "Name is required";
      }

      if (!formData.email.trim()) {
        newErrors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Email is invalid";
      }

      if (!formData.phone.trim()) {
        newErrors.phone = "Phone number is required";
      } else if (!/^(\+91|0)?[6-9]\d{9}$/.test(formData.phone.replace(/\s+/g, ""))) {
        newErrors.phone = "Please enter a valid phone number";
      }

      if (!formData.password) {
        newErrors.password = "Password is required";
      } else if (validatePassword(formData.password)) {
        newErrors.password = validatePassword(formData.password);
      }

      if (!formData.confirmPassword) {
        newErrors.confirmPassword = "Please confirm your password";
      } else if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const submitData = isBusiness
        ? {
            name: formData.name,
            email: formData.email,
            password: formData.password,
            phone: formData.phone,
            role: "business",
          }
        : fromBusiness
          ? { ...formData, role: "business" }
          : {
              name: formData.name,
              email: formData.email,
              password: formData.password,
              phone: formData.phone,
              role: "user",
            };
      dispatch(onRegisterUser(submitData));
    }
  };

  useEffect(() => {
    if (
      registerUserData.status_code === "201" ||
      registerUserData.status_code === 201
    ) {
      const token =
        registerUserData?.registerData?.token ??
        registerUserData?.registerData?.accessToken ??
        registerUserData?.registerData?.data?.token ??
        registerUserData?.registerData?.data?.accessToken;
      ;
      if (token) setAccessToken(token);
      if (savedEnquiryData) {
        dispatch(onEnquiryPost({ ...JSON.parse(savedEnquiryData), email: formData.email }));
      } else {
        dispatch(setIsLoggedIn(true));
        setShowSuccessModal(true);
      }
    } else if (registerUserData.status_code) {
      toast.error(registerUserData.message);
      dispatch(onRegisterUserReset());
    }
  }, [registerUserData, dispatch]);
  useEffect(() => {
    if (enquiryData?.postStatusCode === "201") {
      dispatch(onEnquiryPostReset());
      dispatch(setIsLoggedIn(true));
      setShowSuccessModal(true);
      sessionStorage.removeItem("enquiryData");
    }
  }, [enquiryData?.postStatusCode]);
  const handleSuccessComplete = () => {
    setShowSuccessModal(false);
    const token =
      registerUserData?.registerData?.token ??
      registerUserData?.registerData?.accessToken ??
      registerUserData?.registerData?.data?.token ??
      registerUserData?.registerData?.data?.accessToken;
    if (token) setAccessToken(token);
    dispatch(onRegisterUserReset());
    // Business users (vendor/venue or registered via "list your business") go to completion page
    const isBusinessUser = isBusiness || fromBusiness;
    navigate(isBusinessUser ? "/profile/business" : "/");
  };
  useEffect(() => {
    const enquiryData = JSON.parse(sessionStorage.getItem("enquiryData"));
    if (enquiryData) {
      setFormData({
        name: enquiryData.name,
        email: enquiryData.email,
        phone: enquiryData.phone,
      });
    }
  }, []);
  // User Registration
  if (!isBusiness) {
    return (
      <div className={`register-page ${fromBusiness ? "from-business" : ""}`}>
        <div className="register-page-container">
          <UserRegistrationForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            isLoading={registerUserData.isLoading || enquiryData?.postLoading}
            fromBusiness={fromBusiness}
          />
        </div>

        <SuccessModal
          isOpen={showSuccessModal}
          onClose={() => setShowSuccessModal(false)}
          title="Registration Successful!"
          subtitle={
            fromBusiness
              ? "Redirecting to complete your profile..."
              : "Redirecting you to homepage..."
          }
          onComplete={handleSuccessComplete}
          delay={800}
        />
      </div>
    );
  }

  // Business Registration – same theme/layout as business login (light full page)
  return (
    <div className="business-login-page">
      <header className="business-login-header">
        <div className="business-login-header-inner">
          <Link
            to="/login?type=business"
            className="business-login-back"
            aria-label="Back to business login"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Back to login
          </Link>
          <div className="business-login-brand">
            <span className="business-login-logo">{brand.logoIcon}</span>
            <span className="business-login-name">{brand.name}</span>
          </div>
          <span className="business-login-badge">Business</span>
        </div>
      </header>

      {/* <section className="business-login-hero">
        <div className="business-login-hero-inner">
          <h1 className="business-login-hero-title">Register your business</h1>
          <p className="business-login-hero-subtitle">
            {registerPage.fromBusinessPromoSubtitle || "List your venue or services and reach thousands of couples."}
          </p>
        </div>
      </section> */}

      <main className="business-login-main">
        <div className="business-login-main-inner">
          <aside className="business-login-benefits">
            <h2 className="business-login-benefits-title">Why list with us</h2>
            <ul className="business-login-benefits-list">
              <li>
                <span className="business-login-benefits-icon">✓</span>
                Reach thousands of couples planning their wedding
              </li>
              <li>
                <span className="business-login-benefits-icon">✓</span>
                Manage your venue or vendor profile in one place
              </li>
              <li>
                <span className="business-login-benefits-icon">✓</span>
                Get verified and stand out to couples
              </li>
              <li>
                <span className="business-login-benefits-icon">✓</span>
                Respond to enquiries and grow your business
              </li>
            </ul>
            <p className="business-login-benefits-cta">
              Already have an account?{" "}
              <Link
                to="/login?type=business"
                className="business-login-benefits-link"
              >
                Sign in
              </Link>
            </p>
          </aside>
          <div className="business-login-form-wrap">
            <h2 className="business-login-form-title">
              Create your business account
            </h2>
            <p className="business-login-form-subtitle">
              Same simple signup as user — just Name, Email, Phone and Password.
            </p>
            <div className="business-login-form-inner business-register-form-inner">
              <BusinessSimpleRegistrationForm
                formData={formData}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                isLoading={registerUserData.isLoading}
              />
              <p className="business-register-signin">
                Already have an account?{" "}
                <Link
                  to="/login?type=business"
                  className="business-login-benefits-link"
                >
                  Sign in
                </Link>
              </p>
            </div>
          </div>
        </div>
      </main>

      <footer className="business-login-footer">
        <div className="business-login-footer-inner">
          <Link to="/login" className="business-login-footer-link">
            Not a business? Log in as user
          </Link>
        </div>
      </footer>

      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title="Registration Successful!"
        subtitle="Redirecting to complete your profile..."
        onComplete={handleSuccessComplete}
        delay={800}
      />
    </div>
  );
}

export default RegisterPage;
